/* Open the theme's own Description accordion before scrolling to it. */
document.addEventListener('click', function (event) {
  const link = event.target.closest('[data-du-read-description]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const panel = document.getElementById(link.getAttribute('aria-controls'));
  if (!panel) return;
  const tabs = panel.closest('product-tab');
  const row = panel.closest('.tab-content');
  if (!tabs || !row) return;
  event.preventDefault();
  const mobile = window.innerWidth <= 551;
  const horizontal = tabs.classList.contains('layout-horizontal') || tabs.classList.contains('layout-popup');
  const trigger = !mobile && horizontal
    ? Array.from(tabs.querySelectorAll('.tab-title')).find(a => a.hash === '#' + row.id)
    : row.querySelector('.toggleLink');
  if (trigger && !trigger.classList.contains('is-open')) trigger.click();
  // The theme animates accordion opening; focus only after it becomes visible.
  window.setTimeout(function () {
    panel.setAttribute('tabindex', '-1');
    panel.focus({preventScroll: true});
    row.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
  }, 650);
});
